import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MessageService } from 'primeng/api';
import { RegistrationService } from 'src/app/private/services/registration.service';
import { SharedModule } from 'src/app/private/shared/shared.module';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';

@Component({
  selector: 'app-delete-registration',
  imports: [SharedModule],
  templateUrl: './delete-registration.component.html',
  styleUrl: './delete-registration.component.scss'
})
export class DeleteRegistrationComponent {

    @Output() closeDialog = new EventEmitter();
    isLoading = false;
    @Input() editLeadData: any = {};
    @Output() reload = new EventEmitter<any>();



    handleCloseDialog() {
        this.closeDialog.emit();
    }

    constructor(
      private api : RegistrationService,
      private localStorage: LocalStorageService,
      private messageService: MessageService
    ) { }

    getFullName(user: any) {
      return [user?.prefix, user?.first_name, user?.last_name]
        .filter(name => !!name)
        .join(' ');
    }
  
    handleDelete(){
      this.isLoading = true;
  
      const payload = {
        reg_id: this.editLeadData.registration?.reg_id,
        lead_id: this.editLeadData.lead_id,
        organization_id: this.localStorage.getOrganizationId()
      }
  
      this.api.deleteRegistration(payload).subscribe({
        next: (response) => {
          this.isLoading = false;
          this.reload.emit();
          this.messageService.add({severity:'success', summary: 'Success', detail: 'Lead deleted successfully'});
          this.closeDialog.emit();
        },
        error: (error) => {
          this.messageService.add({severity:'error', summary: 'Error', detail: 'Something went wrong'});
          this.isLoading = false;
        }
      }
      );
  
    }

}
